"use client";

import CarouselSection from "@/components/CarouselSection";
import { useTranslations } from "next-intl";

export default function FlightRouteCampaignsClient({
  campaignsList,
}) {
  const t = useTranslations("flight");
  const tCommon = useTranslations("common");

  return (
    <CarouselSection
      title={t("campaigns")}
      linkText={tCommon("allView")}
      href="/campaigns"
      items={campaignsList}
      componentType="CampaignCard"
      componentProps={{}}
      showDotsFullWidth={true}
      showArrows={true}
    />
  );
}
